import React from "react";
import PropTypes from "prop-types";
import { AppointmentWrapper } from "components/Shared";
import { weekdaysAbrv, monthAbrv } from "lib/date-helpers";
import {
  formatPillTitle,
  formatPillType,
  handleStatus,
} from "lib/status-pill-helpers";
import AppointmentCard from "./AppointmentCard";

function CustomerAppointmentCard({
  apptCardClickHandler,
  form,
  handleSubmit,
  reload,
  showModal,
  setShowModal,
  appointment,
  index,
}) {
  const createdAtTime = appointment?.attributes?.createdAt;
  const appointmentStartTime = appointment?.attributes?.startDatetime;
  const { attributes, include } = appointment;
  const date = new Date(attributes?.startDatetime);
  const day = weekdaysAbrv[date.getDay()];
  const number = date.getDate();
  const month = monthAbrv[date.getMonth()]?.toUpperCase();
  const time = date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  const formatMonthString = `${month} | ${time}`;
  const biz = include?.vendorBusiness.attributes;
  const serv = include?.appointmentLineItems?.data;
  const service = serv ? serv[0].attributes.name : "No Service Selected";
  const staff = include?.employee?.attributes?.name;
  const pet = include?.pet.attributes.name;
  const petImage = include?.pet.attributes?.logo?.sizes?.small?.url;
  const bizType = include?.serviceTypes.data;
  const appointmentStatus = attributes?.status;
  const bizName = biz?.businessName;
  const bizAdd = biz?.formattedAddress;
  const bizImage = biz?.logo?.sizes?.small?.url;
  const skipCustomerStatusUpdates = biz?.skipCustomerStatusUpdates;
  const rescheduleLink = attributes?.rescheduleLink;
  const paymentLink = attributes?.paymentLink;
  const { paymentStatus, skipPayments } = attributes;
  const computedStatus = handleStatus({
    paymentStatus,
    appointmentStatus,
    skipPayments,
    userType: "customer",
    skipCustomerStatusUpdates,
  });
  const pillTitle = formatPillTitle({
    status: computedStatus,
  });
  const pillType = formatPillType({
    status: computedStatus,
  });
  const requestedBy = attributes?.requestedBy;
  const genPending = (status, requested) => {
    const reason = {
      rescheduling: status === "rescheduling",
      providerApproval:
        status === "pending" &&
        (!requested || requested === "customer_request"),
      customerApproval:
        status === "pending" && requested === "provider_request",
    };
    return { reason, status: Object.keys(reason).some((k) => reason[k]) };
  };
  return (
    <AppointmentWrapper key={appointment.id}>
      <AppointmentCard
        status={computedStatus}
        businessName={bizName}
        businessAddress={bizAdd}
        bizImage={bizImage}
        bizId={attributes.vendorBusinessId}
        tippingCompleted={attributes.tippingCompleted}
        day={day}
        endDatetime={attributes.endDatetime}
        id={appointment.id}
        number={number}
        month={formatMonthString}
        pillTitle={pillTitle}
        pillType={pillType}
        petName={pet}
        petImage={petImage}
        showModal={showModal}
        service={service}
        staffName={staff}
        type={bizType}
        totalAmountInt={attributes.stripeCharge}
        rescheduleLink={rescheduleLink}
        paymentLink={paymentLink}
        form={form}
        fieldIndex={index}
        handleSubmit={handleSubmit}
        reload={reload}
        createdAtTime={createdAtTime}
        apptStartTime={appointmentStartTime}
        requestedBy={requestedBy}
        onClick={() => apptCardClickHandler(appointment, index)}
        genPending={() => genPending(appointmentStatus, requestedBy)}
        setShowModal={setShowModal}
      />
    </AppointmentWrapper>
  );
}

CustomerAppointmentCard.propTypes = {
  index: PropTypes.number,
  appointment: PropTypes.shape({
    id: PropTypes.string,
    attributes: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.shape({
        startDatetime: PropTypes.string,
        status: PropTypes.string,
      }),
    ]),
    include: PropTypes.shape({
      vendorBusiness: PropTypes.shape({
        attributes: PropTypes.object,
        id: PropTypes.string,
      }),
      availabilityChannel: PropTypes.shape({
        attributes: PropTypes.shape({
          name: PropTypes.string,
        }),
      }),
      employee: PropTypes.object,
      pet: PropTypes.shape({
        attributes: PropTypes.shape({
          name: PropTypes.string,
          logo: PropTypes.shape({
            sizes: PropTypes.shape({
              small: PropTypes.shape({
                url: PropTypes.string,
              }),
            }),
          }),
        }),
      }),
      serviceTypes: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.shape({}),
      ]),
      appointmentLineItems: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.shape({}),
      ]),
    }),
  }),
  showModal: PropTypes.bool,
  apptCardClickHandler: PropTypes.func,
  form: PropTypes.object,
  handleSubmit: PropTypes.func,
  reload: PropTypes.func,
  setShowModal: PropTypes.func,
};

CustomerAppointmentCard.defaultProps = {
  index: null,
  appointment: {},
  apptCardClickHandler: () => {},
  showModal: false,
  reload: () => {},
  handleSubmit: () => {},
  form: {},
  setShowModal: () => {},
};

export default CustomerAppointmentCard;
